// <s-header-scroll> — marks itself with [data-scrolled] once the page scrolls past a small threshold,
// so the sticky header can tuck away the offers strip with CSS (group-data-[scrolled]).
// One component per file. Uses a sentinel-free, rAF-throttled scroll listener.
class SHeaderScroll extends HTMLElement {
  #ac = null;
  #ticking = false;

  connectedCallback() {
    this.#ac = new AbortController();
    const threshold = Number(this.dataset.threshold || 48);
    const update = () => {
      this.#ticking = false;
      this.toggleAttribute("data-scrolled", window.scrollY > threshold);
    };
    window.addEventListener(
      "scroll",
      () => {
        if (this.#ticking) return;
        this.#ticking = true;
        requestAnimationFrame(update);
      },
      { passive: true, signal: this.#ac.signal },
    );
    update();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get("s-header-scroll")) customElements.define("s-header-scroll", SHeaderScroll);
